import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SleepTrackingCard } from "@/components/SleepTrackingCard";
import { NutritionDashboard } from "@/components/NutritionDashboard";
import { RecipeBrowser } from "@/components/RecipeBrowser";
import { SavedMealsList } from "@/components/SavedMealsList";
import { Button } from "@/components/ui/button";
import { useSleepTracking } from "@/hooks/useSleepTracking";
import { Plus, Heart } from "lucide-react";
import { CreateMealModal } from "@/components/CreateMealModal";

export const FoodLog = () => {
  const { 
    sleepLogs, 
    loading: sleepLoading, 
    logSleep, 
    getWeeklyAverage: getSleepWeeklyAverage,
    getSleepTrend 
  } = useSleepTracking();
  const [showCreateMeal, setShowCreateMeal] = useState(false);

  return (
    <div className="pb-24" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto">
        <Tabs defaultValue="nutrition" className="w-full">
          <div className="border-b border-white/10 p-4 sm:p-6">
            <div className="text-center mb-4">
              <h1 className="text-2xl sm:text-3xl font-normal text-foreground mb-2 flex items-center justify-center gap-2">
                <Heart className="w-6 h-6 sm:w-8 sm:h-8 fill-primary text-primary" />
                HEALTH
              </h1>
              <p className="text-sm sm:text-base text-muted-foreground">
                Track your nutrition, recipes, meals, and sleep for complete wellness
              </p>
            </div>
            <div className="max-w-2xl mx-auto space-y-4">
              <div className="space-y-2">
                <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider px-1">
                  Nutrition
                </h3>
                <TabsList className="grid w-full grid-cols-3 gap-1 p-0.5 sm:gap-1 sm:p-1">
                  <TabsTrigger value="nutrition">Log Food</TabsTrigger>
                  <TabsTrigger value="recipes">Recipes</TabsTrigger>
                  <TabsTrigger value="saved-meals">Saved Meals</TabsTrigger>
                </TabsList>
              </div>
              <div className="space-y-2">
                <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider px-1">
                  Recovery
                </h3>
                <TabsList className="grid w-full grid-cols-1 gap-1 p-0.5 sm:gap-1 sm:p-1">
                  <TabsTrigger value="sleep">Sleep</TabsTrigger>
                </TabsList>
              </div>
            </div>
          </div>

          <TabsContent value="nutrition" className="mt-0 pt-4">
            <NutritionDashboard />
          </TabsContent>

          <TabsContent value="recipes" className="mt-0 p-4 sm:p-6 pt-4">
            <RecipeBrowser />
          </TabsContent>

          <TabsContent value="saved-meals" className="mt-0 p-4 sm:p-6 pt-4">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-normal text-foreground">Your Saved Meals</h2>
              <Button onClick={() => setShowCreateMeal(true)}>
                <Plus className="w-4 h-4 mr-2" />
                Create Meal
              </Button>
            </div>
            <SavedMealsList />
          </TabsContent>

          <TabsContent value="sleep" className="mt-0 p-4 sm:p-6 pt-4">
            <div className="max-w-4xl mx-auto">
              <SleepTrackingCard
                sleepLogs={sleepLogs}
                weeklyAverage={getSleepWeeklyAverage()}
                trend={getSleepTrend()}
                onLogSleep={logSleep}
              />
            </div>
          </TabsContent>
        </Tabs>
      </div>

      <CreateMealModal 
        open={showCreateMeal} 
        onOpenChange={setShowCreateMeal}
        editMeal={null}
      />
    </div>
  );
};
